
import axios from "axios";
import { apiKeyNews } from "../utils/apiKey";
import { getToken } from "../utils/auth";
import { refreshToken } from "./refreshToken";

let isRefreshing = false;
let refreshSubscribers = [];

const onRefreshed = (newToken) => {
    refreshSubscribers.map((callback) => callback(newToken));
};

const addSubscriber = (callback) => {
    refreshSubscribers.push(callback);
};

// export const AxiosBO = (endpoint, setHeader = true) => {
export const AxiosBO = (setHeader = true) => {
   //  const defaultOptions = {
   //      baseURL: endpoint,
   //  };

   const defaultOptions = {}
    if (setHeader === true) {
        defaultOptions.headers = {
            "Content-Type": "application/json"
        }
    }

    // Create instance
    const instance = axios.create(defaultOptions);

    // Set the AUTH token for any request
    instance.interceptors.request.use(function (config) {
      console.log("instance.interceptors", config.url.includes("/meeting/secure/"))
        const { token } = getToken()
        config.headers.authorization = token ? `Bearer ${token}` : "";
         if(!config.url.includes("/meeting/secure/")){
            config.headers.apiKey = atob(apiKeyNews());
         }
        return config;
    });

    // Add response interceptor
    instance.interceptors.response.use(
        response => response,
        error => {
            const originalRequest = error.config;
            console.log('ererrorror', error)
             
            if (
               (error.response.status === 401 && error.response.data === 'TOKEN_EXPIRED' && !originalRequest._retry)
               ||
               (error.response.status === 401 && error.response.data.message === 'jwt expired')
               ||
               (error.response.status === 401 && originalRequest.responseType === 'blob')
            ) {
                if (!isRefreshing) {
                    isRefreshing = true;
                    refreshToken()
                        .then((result) => {
                            isRefreshing = false;
                            instance.defaults.headers.common['authorization'] = `Bearer ${result.newToken}`;
                            instance.defaults.headers.common['apiKey'] = apiKeyNews();
                            onRefreshed(result.newToken);
                        })
                        .catch((error) => {
                            isRefreshing = false;
                            console.error(error)
                        })
                }
                return new Promise((resolve, reject) => {
                    addSubscriber((newToken) => {
                        originalRequest.headers['authorization'] = `Bearer ${newToken}`;
                        resolve(instance(originalRequest));
                    });
                });
            }
            return Promise.reject(error);
        }
    );

    return instance;
};